import { Alert, AlertTitle, Box, Snackbar } from "@mui/material";
import { useLocation } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import Sidebar from "./Sidebar";
import { useDispatch, useSelector } from "react-redux";
import LoginHeader from "../home/LoginHeader";
import Header from "./Header";
import Footer from "../home/Footer";
import { closeNotificationMessage } from "../../store/AlertSlice";

export default function MainLayout() {
  const dispatch = useDispatch();

  const location = useLocation();
  const auth = useSelector((state) => state.auth);
  const alert = useSelector((state) => state.alert);

  const hideLayoutPaths = [
    "/login",
    "/registration",
    "/registration/confirm",
    ,
  ];
  const shouldShowLayout = !hideLayoutPaths.some((path) =>
    location.pathname.startsWith(path)
  );
  const showSidebar =
    shouldShowLayout &&
    auth?.userData &&
    !location.pathname.startsWith("/verification");

  return (
    <>
      {alert?.open && (
        <Snackbar
          open={alert.open}
          autoHideDuration={6000}
          onClose={() => {
            dispatch(closeNotificationMessage());
          }}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            severity={alert.severity || "info"}
            sx={{ width: "100%" }}
            variant="filled"
          >
            <AlertTitle>{alert.message}</AlertTitle>
          </Alert>
        </Snackbar>
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {shouldShowLayout && (
          <>
            <LoginHeader />
            <Header />
          </>
        )}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
            position: "relative",
          }}
        >
          <AppRoutes />
        </Box>
        {shouldShowLayout && <Footer />}
        {showSidebar && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              height: "100vh",
              overflowY: "auto",
            }}
          >
            <Sidebar />
          </Box>
        )}
      </Box>
    </>
  );
}
